import { render, staticRenderFns } from "./editTraindata.vue?vue&type=template&id=1f206dd4"
import script from "./editTraindata.vue?vue&type=script&lang=js"
export * from "./editTraindata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports